module.exports = __webpack_public_path__ + "img/drive-vil-6.4a866ebf.svg";